"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.muiInfoPanelStyles = void 0;
var component_2023_utils_token_parser_1 = require("@rentspree/component-2023.utils.token-parser");
exports.muiInfoPanelStyles = {
    styleOverrides: {
        root: {
            '&.RSPInfoPanel': {
                border: 'none',
                boxShadow: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.info-panel.container.elevation'),
                borderRadius: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.info-panel.container.shape'),
                padding: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.info-panel.container.padding'),
                '& .RSPInfoPanel-space': {
                    height: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.alert.text-container.padding-bt-element'),
                },
                '& .RSPInfoPanel-description': {
                    color: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.info-panel.description-text.color'),
                    fontFamily: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.info-panel.description-text.font'),
                    fontWeight: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.info-panel.description-text.weight'),
                    fontSize: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.info-panel.description-text.size'),
                    letterSpacing: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.info-panel.description-text.letter-spacing'),
                    lineHeight: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.info-panel.description-text.line-height'),
                },
                '& .MuiAlert-icon': {
                    marginRight: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.info-panel.container.padding-bt-element'),
                },
                '& .MuiAlert-icon .MuiSvgIcon-root': {
                    fontSize: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.info-panel.leading-icon.size'),
                },
                '& .MuiAlert-action .MuiButtonBase-root': {
                    marginLeft: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.info-panel.container.padding-bt-element'),
                    marginRight: '8px',
                },
            },
            '&.RSPInfoPanel-severityPrimary': {
                backgroundColor: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.info-panel.container.color'),
                '& .MuiAlert-icon .MuiSvgIcon-root': {
                    color: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.info-panel.leading-icon.color'),
                },
            },
            '&.RSPInfoPanel-severitySecondary': {
                backgroundColor: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.info-panel.secondary.container.color'),
                '& .MuiAlert-icon .MuiSvgIcon-root': {
                    color: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.info-panel.secondary.leading-icon.color'),
                },
            },
            '&.RSPInfoPanel-severityWarning': {
                backgroundColor: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.info-panel.warning.container.color'),
                '& .MuiAlert-icon .MuiSvgIcon-root': {
                    color: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.info-panel.warning.leading-icon.color'),
                },
            },
            '&.RSPInfoPanel-severityCritical': {
                backgroundColor: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.info-panel.critical.container.color'),
                '& .MuiAlert-icon .MuiSvgIcon-root': {
                    color: (0, component_2023_utils_token_parser_1.parseRSPToken)('rsp.comp.info-panel.critical.leading-icon.color'),
                },
            },
        },
    },
};
//# sourceMappingURL=info-panel.js.map